import axios from 'axios';
import { toast } from 'sonner';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Native browser download via short-lived signed link (streams large files to disk)
export const downloadUpload = async (uploadId, filename, token) => {
  try {
    const res = await axios.post(`${BACKEND}/api/admin/uploads/${uploadId}/download-link`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const a = document.createElement('a');
    a.href = `${BACKEND}${res.data.url}`;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    toast.success(`Downloading ${filename}`);
  } catch (err) {
    toast.error(err.response?.status === 404 ? 'File not found on disk' : 'Download failed');
  }
};
